var Turbidity = {

  stage: undefined,
  renderer: undefined,

  wWidth: undefined,
  wHeight: undefined,

  texture: undefined,
  sprite: undefined,

  maxVal: undefined,
  imagesArray: undefined,

  init:function () {
    if($('#turbidity-layer')[0]){
      // this.setStage();
      // this.setRenderer();
      // this.setTexture();
      // this.createObj();
      // this.addStage();
      // this.render();
    }
  },

  setStage: function() {
    this.wWidth = $(window).width();
    this.wHeight =$(window).height();
    this.stage = new PIXI.Container();
    console.log(this.wWidth,this.wHeight);
    console.log(this);
  },


  setRenderer: function() {
    this.renderer = new PIXI.autoDetectRenderer(this.wWidth, this.wHeight,{transparent: true});
    document.getElementById("turbidity-layer").appendChild(this.renderer.view);
  },

  setTexture: function(){
    this.texture = PIXI.Texture.fromImage('/assets/img/common/bg_turbidity.png');
  },

  createObj: function() {
    this.maxVal = 30;
    this.imagesArray = [];
    for(var cnt=0;cnt < this.maxVal;cnt ++){
      this.imagesArray.push(new PIXI.Sprite(this.texture));
      this.imagesArray[cnt].position.x = (Math.random() * 600)-400;
      this.imagesArray[cnt].position.y = (Math.random() * 400)-400;
      this.imagesArray[cnt].anchor.x = 0.5;
      this.imagesArray[cnt].anchor.y = 0.5;
      var base = Math.random() * 3;
      this.imagesArray[cnt].alpha = (base/2) + 0.1;
      this.imagesArray[cnt].scale.x = base/2;
      this.imagesArray[cnt].scale.y = base/2;
      this.stage.addChild(this.imagesArray[cnt]);
    }
  },

  addStage: function() {
    this.stage.addChild(this.sprite);
  },

  render: function() {
    requestAnimationFrame(this.render.bind(this));
    for(cnt=0;cnt <this.maxVal;cnt++){
      var scale = this.imagesArray[cnt].scale.x;
      this.imagesArray[cnt].position.x += (scale * 0.5);
      this.imagesArray[cnt].position.y += (scale * 0.6);
      if(this.imagesArray[cnt].position.y > this.wHeight){
        this.imagesArray[cnt].position.x = Math.random() * -300;
        this.imagesArray[cnt].position.y = Math.random() * -100;

      }
    }
    this.renderer.render(this.stage);
  }



};



module.exports = Turbidity;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_turbidity.js
// module id = 15
// module chunks = 0